import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import useApi from 'utils/hooks/api/useApi';
import { HTTP_VERBS } from 'utils/constants';
import { ALERT_VARIANTS } from 'utils/constants';
import { useRoot } from 'context/RootContext';
import { LOCALIZATION_PAGES } from 'utils/constants';
import { API_ENDPOINTS } from 'utils/constants';

const path = API_ENDPOINTS.SCREENINGS;

const useScreeningDeleteLayout = id => {
  const { t } = useTranslation(LOCALIZATION_PAGES.SCREENINGS);
  const { showNotification } = useRoot();

  const [
    {
      result: deleteScreeningLayoutResult,
      loading: loadingDeleteLayoutScreening,
      error,
      setResult: setDeleteScreeningLayoutResult,
    },
    deleteScreeningLayout,
  ] = useApi(`${path}/${id}/layout`, {
    initialFetch: false,
    verb: HTTP_VERBS.DELETE,
  });

  useEffect(() => {
    if (error) {
      showNotification(
        {
          message: t('layout_delete_failed'),
        },
        ALERT_VARIANTS.DANGER
      );
    }
  }, [error, showNotification, t]);

  useEffect(() => {
    if (deleteScreeningLayoutResult) {
      showNotification({
        message: t('layout_delete_success'),
      });
    }
  }, [deleteScreeningLayoutResult, showNotification, t]);

  return [
    { deleteScreeningLayoutResult, loadingDeleteLayoutScreening, error, setDeleteScreeningLayoutResult },
    deleteScreeningLayout,
  ];
};

export default useScreeningDeleteLayout;
